<template>
  <div class="imei-view-tab">
    <div class="d-flex flex-wrap align-items-center mb-2 imei-view-tab__search-row">
      <div class="imei-view-tab__search flex-grow-1">
        <b-input-group size="sm">
          <b-input-group-prepend is-text>
            <i class="fas fa-search text-muted"></i>
          </b-input-group-prepend>
          <b-input
            :value="searchTerm"
            placeholder="Tìm trong danh sách đã chọn..."
            autocomplete="off"
            @input="$emit('update:searchTerm', $event)"
          />
        </b-input-group>
      </div>
      <ImeiInputModalToolbar
        hide-template
        hide-import
        :export-disabled="exportDisabled"
        @export="$emit('export')"
      />
    </div>

    <div class="imei-modal-stats mb-2">
      <span class="badge badge-light imei-modal-stats__badge">Tổng đã chọn: {{ totalCount }}</span>
      <span class="badge badge-light imei-modal-stats__badge">Kết quả lọc: {{ filteredCount }}</span>
    </div>

    <b-table
      :items="displayItems"
      :fields="tableFields"
      :per-page="perPage"
      :current-page="currentPage"
      bordered
      hover
      small
      class="imei-modal-table mb-2"
    >
      <template #cell(stt)="row">
        <span>{{ viewRowStt(row.index) }}</span>
      </template>
    </b-table>

    <b-pagination
      v-show="filteredCount > perPage"
      :value="currentPage"
      :total-rows="filteredCount"
      :per-page="perPage"
      align="right"
      size="sm"
      class="mb-0"
      @input="$emit('update:currentPage', $event)"
    />
  </div>
</template>

<script>
  import ImeiInputModalToolbar from './ImeiInputModalToolbar.vue'
  import { buildSttRows } from './imeiInputForm.logic'

  export default {
    name: 'ImeiInputViewTab',
    components: { ImeiInputModalToolbar },
    props: {
      items: { type: Array, default: () => [] },
      searchTerm: { type: String, default: '' },
      currentPage: { type: Number, default: 1 },
      perPage: { type: Number, default: 50 },
      totalCount: { type: Number, default: 0 },
      filteredCount: { type: Number, default: 0 },
      exportDisabled: { type: Boolean, default: false },
    },
    computed: {
      tableFields() {
        return [
          {
            key: 'stt',
            label: 'STT',
            thStyle: { width: '56px', fontWeight: 600, color: '#181c32' },
            tdClass: 'text-center',
          },
          {
            key: 'imeiCode',
            label: 'IMEI',
            thStyle: { fontWeight: 600, color: '#181c32' },
          },
        ]
      },
      displayItems() {
        return buildSttRows(this.items)
      },
    },
    methods: {
      viewRowStt(index) {
        return (this.currentPage - 1) * this.perPage + index + 1
      },
    },
  }
</script>

<style scoped>
  .imei-view-tab__search-row {
    gap: 10px 12px;
  }
  .imei-view-tab__search {
    min-width: 200px;
  }
  .imei-modal-stats {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .imei-modal-stats__badge {
    font-size: 12px;
    font-weight: 500;
    color: #3f4254;
    padding: 6px 10px;
  }
</style>
